<template>
    <div class="platform-selector-inline">
        <a-select v-model="selectedPlatform" :mode="multiple ? 'multiple' : 'default'" style="width: 100%">
            <a-select-option
                v-for="option of platforms"
                :key="option"
                :value="option"
                style="display: flex; align-items: center"
            >
                <div class="option-wrapper">
                    <SupsisIcon v-if="option === 'supsis'" color="#25D366" class="option-icon" />
                    <WhatsappIcon v-if="option === 'whatsapp'" color="#25D366" class="option-icon" />
                    <TelegramIcon v-if="option === 'telegram'" class="option-icon" />
                    <MessengerIcon v-if="option === 'messenger'" class="option-icon" />
                    <webIcon v-if="option === 'web'" class="option-icon" color="black;" />
                    <mailIcon v-if="option === 'email'" class="option-icon" />
                    <MetaIcon v-if="option === 'meta-leads'" class="option-icon" />
                    <TrendyolIcon v-if="option === 'trendyol'" class="option-icon" />
                    <InstagramIcon v-if="option === 'instagram'" class="option-icon" special-background-mode />
                    <span v-if="option === 'calendar'" class="md-icon">calendar_month</span>
                    {{ platformName[option] }}
                </div>
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import SupsisIcon from "../../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MessengerIcon from "../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import webIcon from "./svg/WebIcon.vue";
import mailIcon from "../../Mail/icons/MailIcon.vue";
import MetaIcon from "../../Chatbot/pages/integrations/svg/MetaIcon.vue";
import TrendyolIcon from "../../Chatbot/pages/integrations/svg/TrendyolIcon.vue";

export default {
    name: "PlatformSelectorInline",
    components: {
        TrendyolIcon,
        MetaIcon,
        WhatsappIcon,
        TelegramIcon,
        MessengerIcon,
        webIcon,
        mailIcon,
        InstagramIcon,
        SupsisIcon,
    },
    props: {
        value: {
            type: Object,
            default: () => null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        platforms: [
            "web",
            "supsis",
            "calendar",
            "whatsapp",
            "instagram",
            "telegram",
            "email",
            "messenger",
            "meta-leads",
        ],
        platformName: {
            web: "Web",
            supsis: "Supsis",
            calendar: "Calendar",
            whatsapp: "Whatsapp",
            instagram: "Instagram",
            telegram: "Telegram",
            email: "Email",
            messenger: "Messenger",
            "meta-leads": "Meta Leads",
        },
        selectedPlatform: null,
    }),
    mounted() {
        this.selectedPlatform = this.value;
    },
    watch: {
        selectedPlatform() {
            this.$emit("input", this.selectedPlatform);
        },
        value() {
            this.selectedPlatform = this.value;
        },
    },
};
</script>
